import React, { useState } from 'react';
import logo from '../../assets/logo.svg';
import { CardMedia } from '@mui/material';
import { useLocation } from 'wouter';
import { ToastVariant } from '../../types';
import { useSetRecoilState } from 'recoil';
import { toastDataAtom } from '../../tools/Atoms/atoms';
import TwindButton from '../../components/TwindButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import axiosInstance from '../../helper/axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { EMAIL_REGX_VALIDATION } from '../../tools/constants';
import IlaraInput from '../../components/IlaraInput';
const ForgotPassword = () => {
  const [, setLocation] = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const setToastData = useSetRecoilState(toastDataAtom);
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      emailAddress: ''
    },
    validationSchema: Yup.object({
      emailAddress: Yup.string()
        .email('Valid email address is required')
        .required('Email is required')
        .matches(EMAIL_REGX_VALIDATION, 'Valid email address is required')
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        axiosInstance
          .post(`/passwordReset/createForgotPasswordToken?email=${values.emailAddress}`)
          .then((response: any) => {
            setIsLoading(false);
            // localStorage.setItem('AUTH_TOKEN', response.data?.token);
            setLocation('passwordReset/reset');
          })
          .catch(() => {
            // If login failed
            setIsLoading(false);
            // Handle error, maybe display an error message
            setToastData({
              open: true,
              variant: ToastVariant.error,
              title: 'Error',
              description: 'Invalid Email!'
            });
          });
      } catch (error) {
        // console.error('Error occurred:', error);
        setIsLoading(false);
        setToastData({
          open: true,
          variant: ToastVariant.error,
          title: 'Error',
          description: 'Some error occured while Sending Email!'
        });
        // Handle error, maybe display an error message
      }
    }
  });
  return (
    <div className="bg-ilara-blue-login flex flex-col items-center h-screen pt-24">
      <div className="flex items-center">
        <CardMedia sx={{ width: 100, height: 100 }} component="img" image={logo} alt="ilara logo" />
        <p className="ml-1 font-secondary-bold font-semibold text-3xl overflow-hidden whitespace-nowrap uppercase text-ilara-white">
          ILARA HEALTH
        </p>
      </div>
      <div className="bg-white p-8 rounded shadow-md w-full md:w-1/2 lg:w-1/3 mt-16">
        <h1 className="text-2xl font-bold mb-4 text-center">Forgot Password</h1>
        <form>
          <div className="mb-4">
            <IlaraInput
              placeholder="example@domain.com"
              value={validation?.values?.emailAddress}
              name="emailAddress"
              type="email"
              onChange={validation.handleChange}
              label="Email address*"
              error={
                validation?.touched?.emailAddress && validation?.errors?.emailAddress
                  ? validation?.errors?.emailAddress
                  : null
              }
              className="tablet:w-[96%] smallTablet:mb-2 smallTablet:!w-full"
            />
          </div>

          <div className="flex items-center justify-center">
            <TwindButton
              className={`bg-ilara-blue-login text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${
                isLoading ? 'opacity-50 pointer-events-none' : ''
              }`}
              onClick={(e) => {
                e?.preventDefault();
                validation?.handleSubmit();
              }}
              disabled={isLoading}
              variant="primary-login"
              loading={isLoading}
            >
              Reset Password
            </TwindButton>
          </div>
        </form>
        <div className="flex  items-center justify-center mt-4">
          <ArrowBackIosIcon fontSize="small" />

          <p className="text-gray-700 text-sm flex items-center justify-center">
            <div
              className="text-gray-600 hover:text-gray-700 cursor-pointer"
              onClick={() => {
                setLocation('login');
              }}
            >
              Return to Login
            </div>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
